import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BulkGrantDetailResponse } from '@/repositories/generated';

const responses: BulkGrantDetailResponse[] = [
  {
    id: '1',
    name: 'testPublic',
    systemName: 'testBulkGrant',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'SCHEDULED',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
  {
    id: '2',
    name: 'testPublic2',
    systemName: 'testBulkGrant2',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'UPLOAD_PROGRESS',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'PHYSICAL_PREPAID_CARD',
  },
  {
    id: '3',
    name: 'testPublic3',
    systemName: 'testBulkGrant3',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'UPLOAD_FAILURE',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
  {
    id: '4',
    name: 'testPublic4',
    systemName: 'testBulkGrant4',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'SCHEDULED_CANCELED',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
  {
    id: '5',
    name: 'testPublic5',
    systemName: 'testBulkGrant5',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'PROGRESS',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
  {
    id: '6',
    name: 'testPublic6',
    systemName: 'testBulkGrant6',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'DONE',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
  {
    id: '7',
    name: 'testPublic7',
    systemName: 'testBulkGrant7',
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
    grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
    bulkGrantStatus: 'FAILURE',
    detailCount: 15,
    createdBy: 'temp',
    remarks: '',
    scheduleCount: 1,
    scheduleCancelCount: 2,
    grantCount: 3,
    failureCount: 4,
    grantCancelCount: 5,
    createdAt: '2023-01-01T00:00:00+09:00',
    accountType: 'BONUS_VALUE',
    expiredDatePattern: 'YEARS_LATER_SPECIFIC_MONTH_END',
    expiredDateAddValue: 1,
    specifiedMonth: 6,
    fileType: 'APP_USER',
  },
];

export const bulkGrantDetail = http.get(
  createMockEndpoint('/bulk_grant/:id([^\\(generate\\)]+)'), // bulk_grant/generateとの競合を避ける
  async ({ params }) => {
    await delay(500);
    return HttpResponse.json(responses.find((response) => response.id === params.id), { status: 200 });
  },
);
